
import {defineComponent} from "vue";
export default defineComponent({
  name: "icon-right-arrow"
});
